var React = require('react');

function MagnifyingGlassPrimary (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","fill":"#FF5703","d":"M2.26294 8.5532C2.26294 5.09297 5.07648 2.2832 8.55294 2.2832C12.0294 2.2832 14.8429 5.09297 14.8429 8.5532C14.8429 12.0134 12.0294 14.8232 8.55294 14.8232C5.07648 14.8232 2.26294 12.0134 2.26294 8.5532ZM8.55294 0.283203C3.97709 0.283203 0.262939 3.98322 0.262939 8.5532C0.262939 13.1232 3.97709 16.8232 8.55294 16.8232C10.4933 16.8232 12.2786 16.1579 13.6916 15.0431L17.4268 18.7784L18.7979 17.4073L15.0637 13.6731C16.1778 12.2652 16.8429 10.4871 16.8429 8.5532C16.8429 3.98322 13.1288 0.283203 8.55294 0.283203Z"}));
}

MagnifyingGlassPrimary.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = MagnifyingGlassPrimary;

MagnifyingGlassPrimary.default = MagnifyingGlassPrimary;
